import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-add-row',
  templateUrl: './add-row.component.html',
  styleUrls: ['./add-row.component.css']
})

export class AddRowComponent implements OnInit {

  @Input() rowsArray: any;
  @Input() index: number;
  @Input() pop: any;

  constructor() { }

  ngOnInit() {
  }


  addRow(row) {
    this.rowsArray.splice(this.index, 0, row);
    if (this.pop) {
      this.pop.hide()
    }
  }



}
